export const PACKAGE_PERMISSION_ITEMS = {
  data_capture: "Data Capture",
  custom_branding: "Custom Branding",
  text_messaging: "Custom Text Messages",
  email: "Email Marketing",
  microsite: "Social Media Marketing",
  incentive_offer: "Offers & Promotions",
  form_builder: "Survey Creations",
};

export const isEnabledValue = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0 && isEnabledValue(value[0]);
  }

  if (value && typeof value === "object") {
    const nestedValue = value.status ?? value.value ?? value.enabled ?? value.is_active;
    return nestedValue === undefined ? false : isEnabledValue(nestedValue);
  }

  return value === true || value === 1 || value === "1" || value === "true";
};

export const getPackagePermissions = (packageCatalog, packageId) => {
  if (!Array.isArray(packageCatalog) || packageId === null || packageId === undefined) {
    throw new Error("Package membership data is unavailable.");
  }

  return Object.fromEntries(
    Object.entries(PACKAGE_PERMISSION_ITEMS).map(([permission, itemName]) => {
      const packageItem = packageCatalog.find((item) => item?.item_name === itemName);
      const packageValue = packageItem?.package_item_value?.find((item) => (
        String(item?.our_package_id ?? item?.our_package?.id) === String(packageId)
      ));

      return [permission, packageValue ? isEnabledValue(packageValue.value) : null];
    })
  );
};

export const isEventOptionEnabled = (eventOption, service) => {
  return Boolean(eventOption) && isEnabledValue(eventOption[service]);
};

export const isConfiguredServiceAvailable = (eventOption, packagePermissions, service) => {
  const eventOptionKey = service === "custom_branding" ? "water_mark" : service;

  if (!isEventOptionEnabled(eventOption, eventOptionKey)) {
    return false;
  }

  // Existing event configuration remains visible if package verification fails.
  return packagePermissions?.[service] !== false;
};
